import { InfoIcon } from "@au-schein-de/au-ui-library";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { Snackbar } from "~/components/snackbar/snackbar.component";

type ProfileReorderPartialPopupProps = {
	open: boolean;
	onDismiss: () => void;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
};

export function ProfileReorderPartialPopup({
	open,
	onDismiss,
	onMouseEnter,
	onMouseLeave,
}: ProfileReorderPartialPopupProps) {
	const { t } = useTranslation(["profile", "common"]);

	if (!open || typeof document === "undefined") {
		return null;
	}

	return createPortal(
		<div
			className="fixed z-(--z-index-dialog) w-[434px] top-[102px] right-8 max-md:top-auto max-md:bottom-[86px] max-md:left-4 max-md:right-4 max-md:w-auto"
			data-testid="reorder-partial-popup"
		>
			<Snackbar
				className="box-border w-full items-start"
				message={
					<div className="flex gap-3 items-start">
						<span className="shrink-0">
							<InfoIcon size={5} colorToken="gray-300" />
						</span>
						<span>{t("profile:myOrders.reorder.partial.body")}</span>
					</div>
				}
				dismissAriaLabel={t("common:close")}
				onDismiss={onDismiss}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
			/>
		</div>,
		document.body,
	);
}
